import React from 'react';
import { BLOCK_LIBRARY } from './builderModel.js';

export default function BlockLibraryPanel({ onAddBlock }) {
  return (
    <div className="flex h-full min-h-0 flex-col rounded-xl border border-cyan-300/20 bg-[#061020]/70 p-3">
      <p className="mb-2 text-xs font-semibold uppercase tracking-[0.12em] text-cyan-200">Blocks Library</p>
      <div className="min-h-0 flex-1 space-y-2 overflow-y-auto pr-1">
        {BLOCK_LIBRARY.map((item, index) => (
          <button
            key={`${item.type}-${index}`}
            type="button"
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData('application/x-voucher-block-index', String(index));
              e.dataTransfer.setData('application/x-voucher-block-type', item.type);
            }}
            onClick={() => onAddBlock(index)}
            className="w-full rounded-lg border border-cyan-300/25 bg-cyan-500/5 px-2 py-1.5 text-left text-xs text-slate-100 hover:border-cyan-300/45"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
